import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-santosh',
  templateUrl: './santosh.component.html',
  styleUrls: ['./santosh.component.scss']
})
export class SantoshComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getSantosh();
  }

}
